import React from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import VideoLibraryComponent from "./VideoLibraryComponent";

const LibraryContainer = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const libraryId = pathname.includes("/library")
    ? searchParams.get("videoId")
    : null;
  const preferenceName = pathname.includes("/library")
    ? searchParams.get("preferenceName")
    : null;

  return (
    <VideoLibraryComponent
      libraryId={libraryId}
      preferenceName={preferenceName}
    />
  );
};

export default LibraryContainer;
